import React, { ReactNode } from "react";
import Popup from "./Popup";
import './dlgs.css';

export default function YesNoDlg({ title, msg, yes, no, onYes, onNo, onBackdropClose, yesLoading = false, noLoading = false }: YesNoDlgProps) {
    const loading = yesLoading || noLoading;

    const renderButtonContent = (label: ReactNode, showSpinner: boolean) =>
        showSpinner ? (
            <span className="dlg-btn-loading">
                <span className="dlg-btn-spinner" aria-hidden />
                {label}
            </span>
        ) : label;

    return <Popup onClose={loading ? undefined : (onBackdropClose ?? onNo)}>
        <div className='dlg-popup'>
            <div className='orders'>
                <div className='dlg-title'>{title}</div>
                <div className='dlg-msg'>{msg}</div>
            </div>
            <div className='two-buttons-flex'>
                <button type="button" className={'dlg-no-btn'} onClick={onNo} disabled={loading}>{renderButtonContent(no, noLoading)}</button>
                <button type="button" className={'ok-btn dlg-yes-btn'} onClick={onYes} disabled={loading}>{renderButtonContent(yes, yesLoading)}</button>
            </div>
        </div>
    </Popup>
}

type YesNoDlgProps = {
    title: ReactNode;
    msg: ReactNode;
    yes: ReactNode;
    no: ReactNode;
    onYes: () => void;
    onNo: () => void;
    /** When set, clicking outside the dialog calls this instead of `onNo`. */
    onBackdropClose?: () => void;
    yesLoading?: boolean;
    noLoading?: boolean;
}